<h2 mat-dialog-title *ngIf="this.startDate && this.endDate">
  {{ 'searchDialog.SearchResultsFor' | transloco }} "{{ data.query }}" - ({{ this.startDate |  date: 'shortDate' }} - {{ this.endDate |  date: 'shortDate' }})
</h2>

<h2 mat-dialog-title *ngIf="(this.startDate && !this.endDate) || (!this.startDate && this.endDate)">
  {{ 'searchDialog.SearchResultsFor' | transloco }} "{{ data.query }}" - ({{ this.startDate || this.endDate |  date: 'shortDate' }})
</h2>

<h2 mat-dialog-title *ngIf="!this.startDate && !this.endDate">
  {{ 'searchDialog.SearchResultsFor' | transloco }} "{{ data.query }}"
</h2>


<mat-dialog-content>
  <div class="search-bar">
    <mat-form-field appearance="outline" class="search-field">
      <input matInput placeholder="{{'searchDialog.Search'| transloco}}" [formControl]="searchControl" (keyup.enter)="onSearch()" autocomplete="off">
      <button mat-icon-button matSuffix matSuffix (click)="onSearch()" >
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" class="date-range-field">
      <mat-date-range-input [rangePicker]="picker" [formGroup]="dateRange">
        <input matStartDate formControlName="start" placeholder="{{'searchDialog.StartDate'| transloco}}">
        <input matEndDate formControlName="end" placeholder="{{'searchDialog.EndDate'| transloco}}">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </div>
  <div *ngIf="loading">
    <p>{{ 'searchDialog.Loading' | transloco }}...</p>
  </div>
  <div *ngIf="!loading">
    <ng-container *ngIf="groupedResults?.length; else noResults">
      <mat-tab-group>
          <mat-tab *ngFor="let group of groupedResults" [label]="(('searchDialog.' + group.packagingType) | transloco) + ' (' + group.results.length + ')'">
          <table>
            <thead>
              <tr>
                <th >{{ 'searchDialog.Id' | transloco }}</th>
                <th >{{ 'searchDialog.BrandName' | transloco }}</th>
                <th >{{ 'searchDialog.ArticleNumber' | transloco }}</th>
                <th >{{ 'searchDialog.ProductName' | transloco }}</th>
                <th *ngIf="group.packagingType.toLocaleLowerCase() === 'packaging component'" >{{ 'searchDialog.PackagingType' | transloco }}</th>
                <th >{{ 'searchDialog.Date' | transloco }}</th>
                <th >{{ 'searchDialog.Version' | transloco }}</th>
                <th >{{ 'searchDialog.Directory' | transloco }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of group.results">
                <td >
                  <a class="navigate-url" (click)="onNavigate(item)" >{{ item.rootId }}</a>
                </td>
                <td >{{ item.brandName }}</td>
                <td >{{ item.articleNumber }}</td>
                <td >{{ item.productName }}</td>
                <td *ngIf="group.packagingType.toLocaleLowerCase() === 'packaging component'">{{ ('searchDialog.'+ item.componentTypeName ) | transloco  }}</td>
                <td >{{ item.creationTimestamp | date: 'MM/dd/yyyy: hh:mm:ss a' }}</td>
                <td >{{ item.version }}</td>
                <td >
                  <a class="navigate-url" (click)="navigateToDirectory(item)">{{ item.directoryName }}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </mat-tab>
      </mat-tab-group>
    </ng-container>
    <ng-template #noResults>
      <p>{{ 'searchDialog.NoResult' | transloco }}</p>
    </ng-template>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">{{ 'searchDialog.Close' | transloco }}</button>
</mat-dialog-actions>
